import { Container, Stack } from "@mui/material"
import { Page } from "../../../components"
import HeaderBreadcrumbs from "../../../components/header-breadcrumbs"
import { AppointmentsList } from "../../../components/lists/appointments-list"

export const AppointmentsListScreen: React.FC = () => {
    return (
        <Page title="POM - Appointments">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Appointments"
                        links={[
                            {
                                name: 'View all user appointments from your subscription.',
                                href: '/appointments'
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>
                <AppointmentsList />
            </Container>
        </Page>
    )
}